import type { ICampaignConfig } from '../campaignConfig.types';
import { PRIZE_POP_CAMPAIGN_TYPE } from '../../types/campaign.types';
import { SECTION_NAMES } from '@repo/common';

const CAMPAIGNS_API_URLS = {
    PREFIX: 'prizepopservice/api/game-client/prize-pops/',
    GET_CAMPAIGNS: 'get-all',
    JOIN_CAMPAIGN: 'join',
    GET_PRIZES: '/prizes',
    GET_WINS: '/wins'
};

const { PREFIX, GET_CAMPAIGNS, JOIN_CAMPAIGN, GET_PRIZES, GET_WINS } = CAMPAIGNS_API_URLS;

export const prizePopConfig: ICampaignConfig = {
    type: PRIZE_POP_CAMPAIGN_TYPE,
    displayName: 'Prize Pop',
    sectionName: SECTION_NAMES.PRIZE_POP,
    hostSettingsKey: 'prizePopHost',
    mainFetch: {
        urlTemplate: `\${host}${PREFIX}${GET_CAMPAIGNS}`,
        timing: {
            staleTime: 5 * 60 * 1000,
            refetchInterval: 60 * 1000,
            refetchOnWindowFocus: true,
        },
        retry: {
            maxRetries: 2,
            retryDelayBase: 1000,
            maxRetryDelay: 30000,
        },
        queryKeySegments: ['prizePop', 'list'],
    },
    subFetches: {
        prizes: {
            name: 'prizes',
            urlTemplate: `\${host}${PREFIX}\${campaignId}${GET_PRIZES}`,
            timing: {
                staleTime: 30 * 1000,
                refetchInterval: 5 * 1000,
                refetchOnWindowFocus: true,
            },
            retry: {
                maxRetries: 2,
                retryDelayBase: 1000,
                maxRetryDelay: 10000,
            },
            queryKeySegments: ['prizePop', 'prizes'],
        },
        wins: {
            name: 'wins',
            urlTemplate: `\${host}${PREFIX}\${campaignId}${GET_WINS}`,
            timing: {
                staleTime: 30 * 1000,
                refetchInterval: 5 * 1000,
                refetchOnWindowFocus: true,
            },
            retry: {
                maxRetries: 2,
                retryDelayBase: 1000,
                maxRetryDelay: 10000,
            },
            queryKeySegments: ['prizePop', 'wins'],
        },
        join: {
            name: 'join',
            urlTemplate: `\${host}${PREFIX}${JOIN_CAMPAIGN}`,
            method: 'POST',
            timing: {
                staleTime: 0,
                refetchInterval: false,
                refetchOnWindowFocus: false,
            },
            retry: {
                maxRetries: 1,
                retryDelayBase: 1000,
                maxRetryDelay: 5000,
            },
            queryKeySegments: ['prizePop', 'join'],
            buildJoinInRequestData: ({ sessionInfo, url, data }) => {
                const queryString = new URLSearchParams(sessionInfo as any).toString();
                const fullUrl = `${url}?${queryString}`;
                const body = data;

                return {
                    fullUrl,
                    requestBody: body
                }
            }
        },
    },
    mutations: {},
};
